// Dependencies
import React from 'react';

import { RentVsBuyInput } from '../../../../../lib/utils';
import HomeInsuranceInput from '../home-insurance';

const HomeInsuranceInputWithAnalytics: React.FC<RentVsBuyInput> = ({
  label,
  tooltip,
  className,
  fullWidth,
}) => {
  return (
    <HomeInsuranceInput
      label={label}
      tooltip={tooltip}
      className={className}
      fullWidth={fullWidth}
    />
  );
};

export default HomeInsuranceInputWithAnalytics;
